import React, { useState, useEffect, useRef } from "react";
import classes from "./Instruction.module.css";
import logo from "../../../../Assets/logo.png";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Button, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from '../../../../Components/Styles/API/API';
import { ToWords } from 'to-words';
import { HiOutlineMailOpen } from "react-icons/hi";
import { IoCloudDownloadOutline } from "react-icons/io5";
import { IoPrintOutline } from "react-icons/io5";
import { FaEnvelope, FaPrint, FaDownload } from "react-icons/fa";
import { usePDF } from "react-to-pdf";

function Instruction() {
  const navigate = useNavigate();
  const [employeeName, setEmployeeName] = useState('');
  const [employeeNumber, setEmployeeNumber] = useState('');
  const [gender, setGender] = useState('');
  const [grade1, setGrade1] = useState('');
  const [paymentInstruction, setPaymentInstruction] = useState([]);
  const [totalNetPay, setTotalNetPay] = useState(0);
  const [totalNetPayInWords, setTotalNetPayInWords] = useState('');
  const [bankName, setBankName] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const location = useLocation();
  const { rowsToPass, selectedBank, selectedDate, selectedBankName, selectedBankAc  } = location.state;
  const toWords = new ToWords({
    localeCode: 'en-US',
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false,
    currencyOptions: {
      name: 'Naira',
      plural: 'Naira',
    //   name: vouchers?.vouchers[0]?.currency?.currency,
    //   plural: vouchers?.vouchers[0]?.currency?.currency,
    //   symbol: vouchers?.vouchers[0]?.currency?.symbol,
      fractionalUnit: {
        name: 'Kobo',
        plural: 'Kobo',
        // symbol: '',
      },
    }
  }
  });
  const [company, setCompany] = useState('');
  const [bearer, setBearer] = useState('');
  const [continent, setContinent] = useState('');
    const [region, setRegion] = useState('');
    const [province, setProvince] = useState('');
    const [userType, setUserType] = useState('');
    const [instructionLoading, setInstructionLoading] = useState(false);

    const readData = async () => {
      try {
        const value = await localStorage.getItem('userToken');
        const value1 = await localStorage.getItem('companyName');
        const continentName = await localStorage.getItem('continent');
          const regionName = await localStorage.getItem('region');
          const provinceName = await localStorage.getItem('province');
         const admins = await localStorage.getItem('admin');
  
        if (value !== null) {
          setBearer(value);
          // setAuthenticated(true);
        }
        if (value1 !== null) {
          setCompany(value1);
       
        }
        if (continentName !== null) {
          setContinent(continentName);
      }
      if (regionName !== null) {
          setRegion(regionName);
      }
      if (provinceName !== null) {
          setProvince(provinceName);
      }
      if (admins !== null) {
        setUserType(admins);
    }
      } catch (e) {
        alert('Failed to fetch the input from storage');
      }
    };

    useEffect(() => {
      readData();

  }, []);

const [showEmailModal, setShowEmailModal] = useState(false);
  const [email, setEmail] = useState("");
  const printRef = useRef();

   const { toPDF, targetRef } = usePDF({
    filename: "payment_instruction.pdf",
  });

  console.log(rowsToPass)

   const [printed, setPrinted] = useState(false);

const handlePrint = async () => {
   if (printed) {
      window.print();
      return;
    }
  Swal.fire({
    title: "Are you sure?",
    text: "Do you want to print this instruction?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, Print",
    cancelButtonText: "Cancel",
  }).then(async (result) => {
    if (result.isConfirmed) {
      // Show loading Swal
      Swal.fire({
        title: "Please wait",
        text: "Your instruction is being processed for printing...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const ids = rowsToPass.map((row) => row.id);
      const amounts = rowsToPass.map((row) => row?.amountToPay);

      console.log(amounts);
  
      try {
        const response = await axios.post(
          `${BASE_URL}/pay-payables`,
          {
            payable_id: ids,
            payment_bank: selectedBank,
            amount: amounts,
            // payment_description: description,
          },
          { headers }
        );

        Swal.close();

        // ✅ Use hidden iframe for printing (no popup block)
        const printContent = printRef.current.innerHTML;
        const iframe = document.createElement("iframe");
        iframe.style.position = "absolute";
        iframe.style.width = "0px";
        iframe.style.height = "0px";
        iframe.style.border = "none";
        document.body.appendChild(iframe);

        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(`
          <html>
            <head>
              <title>Print</title>
            </head>
            <body>
              ${printContent}
            </body>
          </html>
        `);
        doc.close();

        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        // Remove iframe after printing
        setTimeout(() => document.body.removeChild(iframe), 1000);

        Swal.fire("Success!", response.data.message || "Instruction processed.", "success");
setPrinted(true);
      } catch (error) {
        Swal.close();

        let errorMessage = "An error occurred. Please try again.";
        if (error.response?.data?.message) {
          if (typeof error.response.data.message === "string") {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join("; ");
          } else if (typeof error.response.data.message === "object") {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }

        Swal.fire({
          icon: "error",
          title: "Failed",
          text: errorMessage,
        });
        console.error(error);
      }
    }
  });
};


console.log(rowsToPass)

  const handleSendEmail = () => {
    Swal.fire("Sent!", `Payment instruction sent to ${email}`, "success");
    setShowEmailModal(false);
  };
  // useEffect(() => {
  //   const { vouchers} = location.state;

  //   if (vouchers) {
  //     setBankName(vouchers?.vouchers?.payment_bank[0]?.bank_name);
  //     // setMonth(selectedMonth);
  //     // setYear(selectedYear);
  //     setPaymentInstruction(vouchers?.vouchers);

  //     // const total = vouchers?.vouchers.reduce((acc, item) => acc + parseFloat(item.amount), 0);
  //     // setTotalNetPay(total);

  //     // const totalInWords = convertToWords(total);
  //     // setTotalNetPayInWords(totalInWords);
  
  //   } else {
  //     console.error('No selected item data found in location state.');
  //   }
  // }, [location.state]);

  console.log(rowsToPass)
  
  const generateCurrentDate = () => {
    const currentDate = new Date();
    
    const day = currentDate.getDate().toString().padStart(2, '0');
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const year = currentDate.getFullYear();
  
    const formattedDate = `${day}-${month}-${year}`;
    
    return formattedDate;
  };

  const currentDate = generateCurrentDate();

  const convertToWords = (number) => {
    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = [
      '',
      'Eleven',
      'Twelve',
      'Thirteen',
      'Fourteen',
      'Fifteen',
      'Sixteen',
      'Seventeen',
      'Eighteen',
      'Nineteen',
    ];
    const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  
    const numToWords = (num) => {
      if (num === 0) return '';
      if (num < 10) return units[num];
      if (num < 20) return teens[num - 10];
      if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + units[num % 10] : '');
      if (num < 1000)
        return units[Math.floor(num / 100)] + ' Hundred' + (num % 100 !== 0 ? ' ' + numToWords(num % 100) : '');
      if (num < 1000000)
        return numToWords(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 !== 0 ? ' ' + numToWords(num % 1000) : '');
      return 'Number too large to convert';
    };
  
    const [integerPart, decimalPart] = number.toFixed(2).split('.');
    const integerWords = parseInt(integerPart, 10) !== 0 ? numToWords(parseInt(integerPart, 10)) + ' Naira' : '';
    const decimalWords = parseInt(decimalPart, 10) !== 0 ? ' ' + numToWords(parseInt(decimalPart, 10)) + ' Kobo' : '';
  
    const result = (integerWords + (integerWords && decimalWords ? ',' : '') + decimalWords).trim();
  
    return result;
  };

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
};
  
  
  const total = rowsToPass.reduce((acc, item) => acc + parseFloat(item.amountToPay ?? item.balance), 0);

  const handleInstruction = async () => {
    setInstructionLoading(true);

    const ids = rowsToPass.map(row => row.id);
 
    try {
      const response = await axios.post(`${BASE_URL}/pay-payables`,
        {
         
            payable_id: ids,
            payment_bank: selectedBank,
            amount: rowsToPass.map(row => row.amountToPay)
        
        },
        { headers }
      );
      window.print();


    //  toast.success(response.data.message);
     
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
          }
        //   toast.error(errorMessage)
        Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: errorMessage,
          });
          console.log(error);
      }
    } finally {
      setInstructionLoading(false);
    }
  };

  const handleGoBack = () => {
    navigate(-1);
}
  return (
    <div className={classes.a4size}>
      <div className={classes.header}>
        <h2 className={classes.headerTitle}>PAYMENT INSTRUCTION</h2>
        <div className={classes.iconRow}>
          {/* <FaEnvelope
            className={classes.icon}
            onClick={() => setShowEmailModal(true)}
          /> */}
          <HiOutlineMailOpen className={classes.icon} onClick={() => setShowEmailModal(true)}/>
          <IoPrintOutline className={classes.icon} onClick={handlePrint} />
          <IoCloudDownloadOutline className={classes.icon} onClick={() => toPDF()} />
        </div>
      </div>
      <div ref={printRef}>
      <div ref={targetRef} className={classes.wholeCtDiv}>
        <div className={classes.address}>
          <p style={{fontSize: 15, color: '#000000'}}>
            <strong>To:</strong>
            <br />
            The Branch Manager, <br /> {selectedBankName}.
          </p>

          <p style={{fontSize: 15, color: '#000000'}}>
            {/* Place: */}
            <br /> Date: {currentDate}
          </p>
        </div>

        {/* <p style={{ textAlign: "center", color: '#000000' }}>
          Subject: <strong>{description}</strong>
        </p> */}

        <p style={{fontSize: 15, color: '#000000'}}>Dear Sir/Madam,</p>

        <p style={{fontSize: 15, color: '#000000'}}>
          <span style={{ marginLeft: "40px" }}> We</span>{" "}
          <strong>The Redeemed Christian Church of God</strong> request you to Kindly transfer the
          amount to the following beneficiaries to their respective bank
          accounts by debiting from our account bearing a/c no.{" "}
          <strong>{selectedBankAc}</strong>.
        </p>
        <div>
          <table className={classes.thTable}>
            <thead>
              <tr className={classes.tableHeadRow}>
                <th style={{fontSize: 15}}>S/N</th>
                <th style={{fontSize: 15}}>Account Name</th>
                <th style={{fontSize: 15}}>Bank</th>
                <th style={{fontSize: 15}}>Account No.</th>
                <th style={{ textAlign: "right", fontSize: 15 }}>Amount</th>

                {/* <th>Incl. Total</th> */}
              </tr>
            </thead>
            <tbody>
            {rowsToPass?.map((item, index) => (
                <tr key={index}>
                  <td style={{fontSize: 15}}>{index + 1}</td>
                  <td style={{fontSize: 15, width: 200 }}>{item.supplier?.name || item.customer?.name}</td>
                  <td style={{fontSize: 15}}>{item.supplier?.bank_name || item.customer?.bank_name}</td>
                  <td style={{fontSize: 15}}>{item.supplier?.account_number || item.customer?.account_number}</td>
                  <td style={{ textAlign: "right", fontSize: 15 }}>{parseFloat(item.amountToPay ?? item.balance).toLocaleString('en-US', {
                                          minimumIntegerDigits: 1,
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                        })}
                    </td>
                </tr>
              ))}
            </tbody>
            <tfoot style={{borderBottom: "0.5px solid black", borderTop: "0.5px solid black"}}>
              <tr>
                <td style={{ textAlign: "left", fontSize: 15 }}>
                  <strong>Total</strong>
                </td>
                <td colSpan="3" style={{width: "70%", fontWeight: 500, fontSize: 15}}>

                {total ? toWords.convert(parseFloat(total)) : ''}
                </td>

                <td style={{ textAlign: "right", fontWeight: "bold", fontSize: 15 }}>{total.toLocaleString('en-US', {
                    minimumIntegerDigits: 1,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}</td>
              </tr>
              <tr>
              </tr>
            </tfoot>
          </table>

        </div>
       
        {/* <p style={{ textAlign: "center" }}>Thank You.</p> */}
        <p style={{ textAlign: "right", marginTop: 70, fontSize: 15, color: '#000000' }}>
        For the <strong>[The Redeemed Christian Church of God]</strong>,
      </p>
      <p style={{ textAlign: "right", fontSize: 15, color: '#000000' }}>Authorized Person name & Signatory.</p>
      <div className={classes.printCheque}>
        
    
    {/* <div
        style={{
          marginTop: 20,
          marginBottom: 20,
            justifyContent: "flex-end",
            display: "flex",
            marginLeft: "auto",
            gap: 20,
            width:'100%'
        }}
        >
        <Button variant='danger' onClick={handleGoBack}>Cancel</Button>
        <Button variant="success" onClick={handleInstruction}>
            {instructionLoading ? (
                <>
                    <Spinner size='sm' />
                </>
            ) : (
                "Print"
            )}
        </Button>
    </div> */}
    </div>
        </div>
        </div>
        {showEmailModal && (
        <div className={classes.modalOverlay}>
          <div className={classes.modalContent}>
            <h4>Send Payment Instruction</h4>
            <input
              type="email"
              placeholder="Enter recipient email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="form-control"
            />
            <div style={{ marginTop: 15, display: "flex", gap: 10 }}>
              <Button
                variant="secondary"
                onClick={() => setShowEmailModal(false)}
              >
                Cancel
              </Button>
              <Button variant="primary" onClick={handleSendEmail}>
                Send
              </Button>
            </div>
          </div>
        </div>
      )}
      </div>
   
  );
}
export default Instruction;
